"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const text_1 = require("../simpleGrid/text");
const objectcell_1 = require("./cells/objectcell");
const arraycell_1 = require("./cells/arraycell");
const keautils_1 = require("keautils");
/**Vista por default para una celda */
exports.defaultCellView = (data, sharedData, onDrillDown, string) => {
    const simpleCellResult = string == undefined ? text_1.cellToText(data) : string;
    if (isSimpleCellData(data)) {
        return simpleCellResult;
    }
    if (keautils_1.isArray(data)) {
        return arrayCell()(data, sharedData, onDrillDown, string);
    }
    else if (typeof (data) == "object") {
        return exports.objectCell(data, sharedData, onDrillDown, string);
    }
    else {
        return simpleCellResult;
    }
};
/**Vista para un objeto con capacitdad de hacer un drill down */
exports.objectCell = (data, sharedData, onDrillDown) => {
    return React.createElement(objectcell_1.ObjectCell, { value: data, onDrillDown: onDrillDown });
};
/**Función que devuelve un view dadas las dependencias de un array cell */
function arrayCell(deps) {
    return (data, sharedData, onDrillDown, string) => {
        return React.createElement(arraycell_1.ArrayCell, Object.assign({}, (deps || {}), { value: data, string: string }));
    };
}
exports.arrayCell = arrayCell;
function isSimpleCellData(x) {
    const yy = {};
    if (typeof (x) == "object" && x != null && !(x instanceof Date)) {
        return false;
    }
    return true;
}



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/grid2Base/components/cell.js
// module id = 503
// module chunks = 0